<div class="width-1100">

    <mat-card>
        <mat-toolbar class="toolbar-top">
    
          <div class='title'>
            <mat-icon>store_mall_directory</mat-icon>
            <div>Salas</div>
          </div>
    
          <div flex justify-content='flex-end' fxLayoutAlign="end">
            <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
              autocomplete="off">
            <a mat-button (click)="openDialog(null)" style='width:60px;'>
              <mat-icon color='primary'>add_circle_outline</mat-icon>
            </a>
          </div>
    
        </mat-toolbar>
      </mat-card>


  <mat-card>


  </mat-card>

  <mat-card id='table-body'>
    
    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" 
    matSort 
    matSortActive="name"
    matSortDirection='asc'
    matSortDisableClear=true>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>store_mall_directory</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

    <mat-paginator [pageSizeOptions]="[6, 12, 24, 48]"></mat-paginator>

  </mat-card>

</div>